const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20movie%20award%20ceremony%20visual%20with%20golden%20trophy%20on%20velvet%20pedestal%2C%20warm%20spotlight%2C%20luxurious%20dark%20red%20curtains%2C%20prestigious%20atmosphere%2C%20cinematic%20lighting%2C%20shallow%20depth%20of%20field&width=640&height=420&seq=card-oscar-01&orientation=landscape',
    tag: '奥斯卡',
    title: '2026奥斯卡获奖影片全收录',
    desc: '本届奥斯卡最佳影片、最佳导演、最佳男女主角获奖作品一站式观看，影迷必收。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20scene%20with%20dramatic%20mountain%20landscape%2C%20flowing%20silk%20robes%2C%20misty%20atmosphere%2C%20traditional%20architecture%2C%20poetic%20composition%2C%20warm%20earthy%20toned%20color%20palette&width=640&height=420&seq=card-chinese-02&orientation=landscape',
    tag: '华语之光',
    title: '近十年华语电影巅峰之作',
    desc: '从《我不是药神》到《流浪地球》，盘点改变中国电影格局的里程碑作品。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Summer%20evening%20outdoor%20cinema%20scene%20with%20string%20lights%2C%20cozy%20blankets%2C%20warm%20sunset%20sky%2C%20nostalgic%20vibe%2C%20friends%20gathering%20atmosphere%2C%20golden%20hour%20photography%20style&width=640&height=420&seq=card-summer-03&orientation=landscape',
    tag: '夏日片单',
    title: '适合夏天的30部治愈电影',
    desc: '冰西瓜配好电影，精选夏日氛围感拉满的影片，陪你度过炎热的午后和微凉的夜晚。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Noir%20style%20crime%20film%20aesthetic%20with%20rainy%20city%20street%2C%20neon%20sign%20reflections%2C%20detective%20shadow%2C%20moody%20atmosphere%2C%20deep%20blues%20and%20contrasting%20warm%20lights%2C%20mysterious%20urban%20night&width=640&height=420&seq=card-crime-04&orientation=landscape',
    tag: '真实改编',
    title: '根据真实事件改编的犯罪片',
    desc: '比虚构更震撼的真实案件，这些犯罪电影让你感受到现实比剧本更加离奇和深刻。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20visual%20with%20natural%20world%20exploration%20theme%2C%20majestic%20wildlife%20silhouette%2C%20golden%20savanna%20sunrise%2C%20epic%20scale%2C%20cinematic%20documentary%20style%2C%20warm%20earth%20tones&width=640&height=420&seq=card-doc-05&orientation=landscape',
    tag: '纪录片',
    title: '豆瓣9分以上必看纪录片',
    desc: '从自然奇观到人文历史，精选高分纪录片带你用另一种视角认识这个广阔的世界。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Independent%20film%20aesthetic%20with%20artistic%20composition%2C%20film%20grain%20texture%2C%20warm%20analog%20color%20palette%2C%20minimalist%20scene%2C%20creative%20lighting%2C%20arthouse%20cinema%20vibe&width=640&height=420&seq=card-indie-06&orientation=landscape',
    tag: '独立佳作',
    title: '不容错过的小众独立电影',
    desc: '没有大制作的光环，却有着最真诚的表达。这些独立电影用独特视角讲述动人故事。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              精心策划的电影专题，帮你发现每一部值得看的好片
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card, i) => (
              <a
                key={i}
                href="#cards"
                onClick={(e) => e.preventDefault()}
                className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={`快看影视 - ${card.title}`}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500/85 backdrop-blur-sm text-white text-xs font-medium">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}